exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".eye-mask1{top:408px}.eye-mask1,.eye-mask2{display:flex;position:absolute;right:40px;cursor:pointer}.eye-mask2{top:485px}#eye-1{display:none}", ""]);

// exports
